export const REACT_AUTH_KEY = 'easyroom_auth_key'
